// extracted by mini-css-extract-plugin
export var card = "_7x-1";
export var container = "_7x-0";